import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexSupportDocumentRequest = ({ dispatch, params, successCallback, callback }) => {
  ApiService.request('get', '/support_documents', {
    dispatch,
    params,
    successCallback,
    callback
  });
};

export const showSupportDocumentRequest = (id, { dispatch, params, successCallback, callback }) => {
  ApiService.request('get', `/support_documents/${id}/`, {
    dispatch,
    params,
    successCallback,
    callback
  });
};

export const createSupportDocumentRequest = ({ dispatch, params, formData, successCallback, callback }) => {
  ApiService.request('post', '/support_documents', {
    dispatch,
    params,
    formData,
    successCallback,
    callback
  });
};

export const updateSupportDocumentRequest = (id, { dispatch, params, formData, successCallback, callback }) => {
  ApiService.request('put', `/support_documents/${id}/`, {
    dispatch,
    params,
    formData,
    successCallback,
    callback
  });
};

export const destroySupportDocumentRequest = (id, { dispatch, params, successCallback, callback }) => {
  ApiService.request('delete', `/support_documents/${id}/`, {
    dispatch,
    params,
    successCallback,
    callback
  });
};

export const downloadSupportDocumentRequest = (id, { dispatch, params, formData, successCallback, callback }) => {
  ApiService.request('get', `/support_documents/${id}/download_document`, {
    dispatch,
    params,
    formData,
    responseType: 'blob',
    successCallback,
    callback
  });
};

export const debounceIndexSupportDocumentRequest = AwesomeDebouncePromise(indexSupportDocumentRequest, 300);
